/** "Account Type:" — one colon, even when the authored label already ends with one (QA D-11
 *  printed "Account Type::"). A label that already ends a sentence or a question — "I am a tax
 *  resident of Canada.", "Do you wish to set up a DCA?" — reads as is: "Canada.:" was the second
 *  half of D-11. A French label keeps its space before the colon. */
export function withColon(label: string): string {
  return /[:.?!]\s*$/.test(label) ? label.replace(/\s+$/, '') : `${label}:`;
}
